import _classCallCheck from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _inherits from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

import { SearchBaseClass } from "../../helpers/search";

var GIPHY = /*#__PURE__*/function (_SearchBaseClass) {
  _inherits(GIPHY, _SearchBaseClass);

  var _super = _createSuper(GIPHY);

  function GIPHY(apiKey) {
    _classCallCheck(this, GIPHY);

    return _super.call(this, {
      apiKey: apiKey,
      name: "giphy",
      icon: "<svg aria-hidden=\"true\" viewBox=\"0 0 256 256\" xmlns=\"http://www.w3.org/2000/svg\"><g fill-rule=\"nonzero\" fill=\"none\"><path fill=\"#000\" d=\"M54 29h149v198H54z\"/><path fill=\"#04FF8E\" d=\"M24 22h30v212H24z\"/><path fill=\"#8E2EFF\" d=\"M203 80h30v154h-30z\"/><path fill=\"#00C5FF\" d=\"M24 227h209v29H24z\"/><path fill=\"#FFF152\" d=\"M24 0h119v29H24z\"/><path fill=\"#FF5B5B\" d=\"M203 59V29h-30V0h-30v88h90V59\"/><path fill=\"#551C99\" d=\"M203 117V88h30\"/><path fill=\"#999131\" d=\"M143 0v29h-29\"/></g></svg>",
      color: "#a800ff",
      noRecolor: true,
      poweredByUrl: "https://giphy.com",
      popularEndpoint: function popularEndpoint(apiKey) {
        return "https://api.giphy.com/v1/gifs/trending?api_key=".concat(apiKey, "&limit=18&rating=G");
      },
      searchEndpoint: function searchEndpoint(apiKey, query) {
        return "https://api.giphy.com/v1/gifs/search?api_key=".concat(apiKey, "&q=").concat(encodeURIComponent(query), "&limit=18&offset=0&rating=G&lang=en");
      },
      getButton: function getButton(image) {
        return "<div class=\"result\">\n        <button aria-label=\"".concat(image.title, "\" data-full-url=\"").concat(image.images.downsized_large.url, "\" style=\"background-image: url('").concat(image.images.preview_gif.url, "')\"></button></div>");
      },
      getSearchResults: function getSearchResults(response) {
        return response.data;
      },
      getPopularResults: function getPopularResults(response) {
        return response.data;
      }
    });
  }

  return GIPHY;
}(SearchBaseClass);

export { GIPHY as default };